<template>
  <div class="layout-main">
    <div class="wp-con clearfix">
      <div class="official-left">
        <UserBox
          :xla="{
            show: 'home_user_module_show',
            click: 'home_user_module_click'
          }"
        />
        <ServerList
          :xla="{
            show: 'home_server_module_show',
            click: 'home_server_module_click',
            itemClick: 'home_server_item_click'
          }"
        />
      </div>
      <div class="official-right">
        <div class="content-area official-server-area">
          <div class="title">
            <span class="left">区服选择</span>
            <TitleRight
              :list="['区服选择']"
              @title-click="
                $xlaGamePush('server_page_click', {
                  game_id: $route.params.game_id,
                  click_id: 'bread_crumb'
                })
              "
            />
          </div>
          <div class="content">
            <div class="mod">
              <div class="sub-tit">我的服务器</div>
              <ul class="server-area-list server-area-list01">
                <li
                  v-for="(item, index) in (latest_server_list || []).slice(
                    0,
                    8
                  )"
                  :key="index.server_id"
                  @click="
                    gameStat(`WDYX${index + 1}`, `我的游戏${index + 1}`, item)
                  "
                >
                  <div v-if="item.last_login_time && item.title">
                    <span>{{ item.title }}</span>
                    <em>{{ formattingTime(item.last_login_time) }}</em>
                  </div>
                </li>
              </ul>
            </div>
            <div class="item">
              <div class="sub-tit">推荐服务器</div>
              <ul class="server-area-list server-area-list01">
                <li
                  v-for="(item, index) in (new_server_list || []).slice(0, 3)"
                  :key="index.server_id"
                  @click="gameStat(`TJ${index + 1}`, `推荐${index + 1}`, item)"
                >
                  <div>
                    <span>{{ item.title }}</span>
                    <em>{{ convertTime(item) }}日新开</em>
                  </div>
                </li>
              </ul>
            </div>
            <div v-if="new_server_advance.length > 0" class="item">
              <div class="sub-tit">新服预告</div>
              <ul
                class="server-area-list server-area-list01 new-server-area-list"
              >
                <li
                  v-for="(item, index) in new_server_advance || []"
                  :key="index.server_id"
                >
                  <div>
                    <span>{{ item.title }}</span>
                    <em>{{ convertTime(item) }}日开启</em>
                  </div>
                </li>
              </ul>
            </div>
            <div class="item">
              <div class="sub-tit">选择服务器</div>
              <div class="server-tab-box">
                <span
                  v-for="(m, i) in subscript"
                  :key="i"
                  :class="{ active: active == m.title }"
                  @click="
                    switchServerDisplay(m)
                    activeIndex = i
                    $util.clickStat(
                      `${
                        $route.params.game_id
                      }/GW/GDFWQ/TABXF${subscript.length - activeIndex}`,
                      `${
                        $route.params.game_id
                      }/官网/更多服务器/TAB选服${subscript.length -
                        activeIndex}`
                    )
                  "
                  >{{ m.title }}</span
                >
              </div>
              <ul class="server-area-list server-area-list01">
                <li
                  v-for="(m, i) in currentServerList"
                  :key="i.server_id"
                  @click="
                    gameStat(
                      `XF${subscript.length - activeIndex}`,
                      `选服${subscript.length - activeIndex}`,
                      m
                    )
                  "
                >
                  <div>
                    <span>{{ m.title }}</span>
                    <strong
                      v-if="m.serverState === 'new'"
                      class="server-tab server-tab-new"
                      >新服</strong
                    >
                    <strong
                      v-else-if="m.serverState === 'hot'"
                      class="server-tab server-tab-hot"
                      >火爆</strong
                    >
                    <strong v-else class="server-tab server-tab-full"
                      >满员</strong
                    >
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import UserBox from '~/components/game-offical/common/UserBox'
import ServerList from '~/components/game-offical/common/ServerList'
import TitleRight from '~/components/game-offical/common/TitleRight'
export default {
  layout: 'game',
  components: {
    UserBox,
    ServerList,
    TitleRight
  },
  data() {
    return {
      serverId: null,
      latest_server_list: [],
      new_server_list: [],
      new_server_advance: [],
      allServerList: [],
      subscript: [],
      active: '111-101',
      currentServerList: [],
      activeIndex: 0
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo
    }
  },
  mounted() {
    this.$xlaGamePush('server_page_show')
  },
  created() {
    /* 最近玩过的区服 */
    if (process.client) {
      this.$request('gameRecently', {
        body: { game_id: this.$route.params.game_id }
      }).then((data = [{}]) => {
        this.latest_server_list =
          Object.keys(data[0]).length && data[0].latest_server_list
            ? data[0].latest_server_list
            : []
      })
    }
    /* 最新区服 */
    if (process.client) {
      this.$request('newOpenServer', {
        body: { game_id: this.$route.params.game_id }
      }).then((data = [{}]) => {
        this.new_server_list = data || []
      })
    }
    /* 新区预告 */
    if (process.client) {
      this.$request('newServer', {
        body: { game_id: this.$route.params.game_id }
      }).then((data = []) => {
        this.new_server_advance = data || []
      })
    }
    /* 所有区服 */
    if (process.client) {
      this.$request('gameServerList', {
        body: { game_id: this.$route.params.game_id }
      }).then((data = [{}]) => {
        this.allServerList = data.concat().reverse() || []
        const serverListLen = this.allServerList.length
        this.allServerList = this.allServerList.map((item, i) => {
          let _serverState = ''
          if (serverListLen <= 11) {
            _serverState = i === serverListLen - 1 ? 'new' : 'hot'
          } else if (i === serverListLen - 1) {
            _serverState = 'new'
          } else if (i >= serverListLen - 11 && i <= serverListLen - 2) {
            _serverState = 'hot'
          } else {
            _serverState = 'full'
          }
          return Object.assign({}, item, {
            serverState: _serverState
          })
        })
        this.filtrateMenuFormat()
      })
    }
  },
  methods: {
    // 处理筛选项
    filtrateMenuFormat() {
      const len = this.allServerList.length
      const sub = []
      for (let i = 0; i < len; i += 50) {
        const min = i + 1
        let max = 0
        if (len === 1) {
          max = 1
        } else if (len < 50 || len < i + 50) {
          max = len
        } else {
          max = i + 50
        }
        const _obj = {
          min,
          max,
          title: max + '-' + min
        }
        sub.push(_obj)
      }
      this.subscript = sub.reverse()
      // 选中第一项
      this.switchServerDisplay(this.subscript[0])
    },
    // 切换
    switchServerDisplay(m) {
      if (this.active === m.title) {
        return false
      }
      this.active = m.title

      this.currentServerList = this.allServerList
        .slice(m.min - 1, m.max)
        .reverse()
    },
    goServer({ server_id } = {}) {
      if (!server_id) {
        server_id = (this.lastPlayed[0] || {}).server_id
      }
      this.$router.push({
        path: './play',
        query: { server_id }
      })
    },
    // 格式化时间
    formattingTime(time) {
      const date = new Date(time)
      const diff = (new Date().getTime() - date.getTime()) / 1000
      const dayDiff = Math.floor(diff / 86400)

      const isValidDate =
        Object.prototype.toString.call(date) === '[object Date]' &&
        !isNaN(date.getTime())
      if (!isValidDate) {
        window.console.error('不是有效日期格式')
      }
      return (
        (dayDiff === 0 &&
          ((diff < 60 && '刚刚') ||
            (diff < 120 && '1分钟前') ||
            (diff < 3600 && Math.floor(diff / 60) + '分钟前') ||
            (diff < 7200 && '1小时前') ||
            (diff < 86400 && Math.floor(diff / 3600) + '小时前'))) ||
        (dayDiff === 1 && '昨天') ||
        (dayDiff <= 100 && dayDiff + '天前') ||
        (dayDiff > 100 && dayDiff <= 180 && '3个月前') ||
        (dayDiff > 180 && dayDiff < 365 && '半年前') ||
        '一年前'
      )
    },
    // 转换时间
    convertTime({ opened_at }) {
      return dayjs(opened_at).format('DD')
    },
    gameStat(eid, eid_desc, game) {
      const { game_id, server_id } = game
      this.$util.gameStat(
        game_id,
        server_id,
        `${this.$route.params.game_id}/GW/GDFWQ/${eid}`,
        `${this.$route.params.game_id}/官网/更多服务器/${eid_desc}`
      )
    }
  }
}
</script>
